import React from 'react';
import PropTypes from 'prop-types';

/**
 * Error Boundary component (React 16)
 */
class ErrorBoundary extends React.Component {
	/**
	 * Constructor
	 *
	 * @param {Object} props
	 */
	constructor( props ) {
		super( props );
		this.state = { hasError: false };
	}

	/**
	 * To catch errors
	 *
	 * @param {Object} error
	 * @param {Object} info
	 */
	componentDidCatch( error, info ) {
		// Display fallback UI
		this.setState( { hasError: true, error, info } );
		// You can also log the error to an error reporting service
		// console.log( error, info );
	}

	/**
	 * Render child error message or components
	 */
	render() {
		if ( this.state.hasError ) {
			// You can render any custom fallback UI
			return (
				<div className={ this.props.className }>
					<h2>{ this.props.message }</h2>
				</div>
			);
		}
		return this.props.children;
	}
}

/**
 * Valid props
 */
ErrorBoundary.propTypes = {
	children: PropTypes.node.isRequired,
	message: PropTypes.string.isRequired,
	className: PropTypes.string,
};

/**
 * When a prop is not passed down by the parent component.
 */
ErrorBoundary.defaultProps = {
	message: `${ LearnDashData.i18n.error }`,
	className: '',
};

export default ErrorBoundary;
